require('./input-mode')(document, window);

// ========== ЯНДЕКС МЕТРИКА — СОБЫТИЯ ==========
// Вспомогательная функция: безопасный вызов цели метрики
function ymGoal(goalName) {
	try { ym(108410531, 'reachGoal', goalName); } catch(e) {}
	try { ym(21333037,  'reachGoal', goalName); } catch(e) {}
}

// Клик по телефону — phone_click
// Клик по email   — email_click
// Клик по мессенджеру (Telegram, WhatsApp, Viber, VK, MAX) — messenger_click
// Переход в соцсеть (VK, Instagram, Pinterest, OK, YouTube, Rutube, TikTok) — social_click
document.addEventListener('click', function(e) {
	var link = e.target.closest('a[href]');
	if (!link) return;
	var href = link.getAttribute('href') || '';

	if (href.indexOf('tel:') === 0) {
		ymGoal('phone_click');
		return;
	}
	if (href.indexOf('mailto:') === 0) {
		ymGoal('email_click');
		return;
	}
	var messengerDomains = ['t.me/', 'wa.me/', 'api.whatsapp.com', 'viber.com', 'vk.me/', 'max.ru/'];
	for (var i = 0; i < messengerDomains.length; i++) {
		if (href.indexOf(messengerDomains[i]) !== -1) {
			ymGoal('messenger_click');
			return;
		}
	}
	var socialDomains = ['vk.com', 'instagram.com', 'pinterest.com', 'ok.ru', 'odnoklassniki.ru', 'youtube.com', 'rutube.ru', 'tiktok.com'];
	for (var j = 0; j < socialDomains.length; j++) {
		if (href.indexOf(socialDomains[j]) !== -1) {
			ymGoal('social_click');
			return;
		}
	}
});
// ========== /ЯНДЕКС МЕТРИКА — СОБЫТИЯ ==========

// Фиксируем высоту viewport один раз при загрузке (без обновления при скролле),
// чтобы preview-секция не "зумила" картинку при скрытии адресной строки на мобильных
(function() {
	document.documentElement.style.setProperty('--real-vh', window.innerHeight + 'px');

	// Lazy loading для всех картинок и видео (кроме первого экрана)
	document.querySelectorAll('img:not(.preview__image img):not(.header img)').forEach(function(img) {
		if (!img.hasAttribute('loading')) {
			img.setAttribute('loading', 'lazy');
		}
	});
	document.querySelectorAll('video').forEach(function(video) {
		if (!video.hasAttribute('preload') || video.getAttribute('preload') !== 'none') {
			video.setAttribute('preload', 'none');
		}
	});
})();

// Resize
$(window).on("resize", function () {

});


// Scroll
$(window).on("scroll", function () {

})


//accordion//
document.addEventListener('DOMContentLoaded', function() {
	// Получаем все элементы аккордеона
	var accordionItems = document.querySelectorAll('.accordion-block-item');

	// Перебираем каждый элемент аккордеона
	accordionItems.forEach(function(item) {
		// Находим заголовок и контент для текущего элемента
		var header = item.querySelector('.accordion-block-item-header');
		var content = item.querySelector('.accordion-block-item-content');
		var btn = item.querySelector('.accordion-block-item-toggle'); // Правильный селектор для кнопки

		// Проверяем, что заголовок, контент и кнопка существуют
		if (header && content && btn) {
			// Добавляем обработчик клика для заголовка
			header.addEventListener('click', function() {
				// Переключаем видимость контента при клике на заголовок
				content.classList.toggle('active');
				btn.classList.toggle('active'); // Также переключаем класс у кнопки
			});
		}
	});
});
//accordion//

// Document click
$(document).on("click", function (e) {

});

// ========== HEADER MENU ==========
const headerBurger = document.querySelector('#headerBurger');
const headerMobileMenu = document.querySelector('#headerMobileMenu');
const body = document.querySelector('body');

if (headerBurger && headerMobileMenu) {
    // Открытие/закрытие мобильного меню
    headerBurger.addEventListener('click', function () {
        headerBurger.classList.toggle('active');
        headerMobileMenu.classList.toggle('active');
        body.classList.toggle('no-scroll');
    });

    // Бургер-меню работает на всех разрешениях

    // Закрытие меню при клике вне его области
    document.addEventListener('click', function (event) {
        if (!headerMobileMenu.contains(event.target) &&
            !headerBurger.contains(event.target) &&
            headerMobileMenu.classList.contains('active')) {
            headerBurger.classList.remove('active');
            headerMobileMenu.classList.remove('active');
            body.classList.remove('no-scroll');
        }
    });
}
// ========== /HEADER MENU ==========


document.addEventListener("DOMContentLoaded", function() {
	var menuLists = document.querySelectorAll('.footer-block-menu-list');
	menuLists.forEach(function(list) {
	  if (list.children.length > 6) {
		list.classList.add('two-columns');
	  }
	});
});

// Footer accordion - раскрытие подкатегорий по клику на стрелку
document.addEventListener("DOMContentLoaded", function() {
	var toggleBtns = document.querySelectorAll('.footer__toggle');
	toggleBtns.forEach(function(btn) {
		btn.addEventListener('click', function(e) {
			e.preventDefault();
			var item = btn.closest('.footer__item--has-children');
			if (!item) return;
			var sublist = item.querySelector('.footer__sublist');
			if (!sublist) return;
			btn.classList.toggle('is-open');
			sublist.classList.toggle('is-open');
		});
	});
});

// popups
$(".popup__close, .popup__cancel").on("click", function (e) {
	$("body").removeClass("no-scroll");
	$(this).closest(".popup").removeClass("active");
});

$(".popup").on("click", function (e) {
	var callbackPopup = $(".popup__card")
	if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
		$(this).removeClass("active");
		$("body").removeClass("no-scroll");
	};
});

$("[data-popup-open]").on("click", function (e) {
	e.preventDefault();
	let dataPopupName = $(this).attr("data-popup-open");
	let popup = $(".popup[data-popup-name=" + dataPopupName + "]");
	$("body").addClass("no-scroll");
	popup.addClass("active");
});

//PREVIEW//
if ($(window).width() <= 768) {
	$('.preview-block').addClass('no-click');
}

$(document).ready(function() {
	// Обработчик события клика по блоку
	$('.preview-block').on('click', function() {
		// Удаляем класс no-click после первого клика на мобильном устройстве
		$(this).removeClass('no-click');
	});
});
//PREVIEW//

//MAPS//
$('.mapContainer').each(function() {
	var mapTitle = $('<div>').addClass('mapTitle');
	mapTitle.text('Для активации карты нажмите по ней');
	$(this).append(mapTitle);

	$(this).on('click', function() {
		$(this).children(':first').removeAttr('style');
		mapTitle.remove();
	});

	$(this).on('mousemove', function(event) {
		mapTitle.css('display', 'block');
		if (event.offsetY > 10) mapTitle.css('top', event.offsetY + 20 + 'px');
		if (event.offsetX > 10) mapTitle.css('left', event.offsetX + 20 + 'px');
	});

	$(this).on('mouseleave', function() {
		mapTitle.css('display', 'none');
	});
});
//MAPS//

//preview slider//
$(document).ready(function() {
	function initializePreviewSwiper() {
		if (document.querySelector('.preview-slider-main')) {
			if (window.innerWidth >= 768) {
				if (!window.previewSwiperInstance) {
					// Инициализация Swiper
					window.previewSwiperInstance = new Swiper(".preview-slider-main", {
						spaceBetween: 24,
						navigation: {
							nextEl: ".preview-slider-btn-next",
							prevEl: ".preview-slider-btn-prev",
						},
						pagination: {
							el: ".preview-pagination",
							type: "fraction",
						},
						thumbs: {
							swiper: new Swiper(".preview-slider-img", {
								spaceBetween: 24,
								slidesPerView: 1,
								freeMode: true,
								watchSlidesProgress: true,
							}),
						},
					});
				} else {
					// Отложенное обновление Swiper через 100 мс
					setTimeout(() => {
						if (window.previewSwiperInstance) {
							window.previewSwiperInstance.update();
						}
					}, 100);
				}
			} else if (window.previewSwiperInstance) {
				// Отложенное уничтожение Swiper через 100 мс
				setTimeout(() => {
					if (window.previewSwiperInstance && document.querySelector('.preview-slider-main')) {
						window.previewSwiperInstance.destroy(true, true);
						window.previewSwiperInstance = null;
					}
				}, 100);
			}
		}
	}

	// Инициализация при загрузке страницы
	window.addEventListener('load', initializePreviewSwiper);
	// Инициализация при изменении размера окна
	window.addEventListener('resize', initializePreviewSwiper);
	// Инициализация при смене ориентации экрана
	window.addEventListener('orientationchange', initializePreviewSwiper);
});
//preview slider//

//preview category slider//
$(document).ready(function() {
	var previewCategoryEl = document.querySelector('.preview-category-slider');
	if (previewCategoryEl) {
		var slideCount = previewCategoryEl.querySelectorAll('.swiper-slide').length;
		var desktopPerView = Math.min(slideCount, 3);

		new Swiper(".preview-category-slider", {
			slidesPerView: 1,
			spaceBetween: 0,
			loop: slideCount > 1,
			autoplay: slideCount > 1 ? {
				delay: 5000,
				disableOnInteraction: false,
			} : false,
			pagination: {
				el: ".preview-category-pagination",
				clickable: true,
			},
			breakpoints: {
				1024: {
					slidesPerView: desktopPerView,
					slidesPerGroup: desktopPerView,
					spaceBetween: desktopPerView > 1 ? 4 : 0,
				}
			}
		});
	}
});
//preview category slider//

//designer slider//
$(document).ready(function() {
	document.querySelectorAll('[data-designer-slider]').forEach(function(slider) {
		if (!slider.classList.contains('swiper-initialized')) {
			var paginationEl = slider.closest('.category-designers__slider-wrap').querySelector('.category-slider-pagination');
			new Swiper(slider, {
				slidesPerView: 1,
				spaceBetween: 0,
				loop: true,
				pagination: {
					el: paginationEl,
					clickable: true
				}
			});
		}
	});
});
//designer slider//

//catalog slider//
$(document).ready(function() {
	function initializeCatalogSwiper() {
		if (document.querySelector('.card-slider-block')) {
			if (window.innerWidth >= 768) {
				if (!window.catalogSwiperInstance) {
					// Инициализация Swiper
					window.catalogSwiperInstance = new Swiper(".card-slider-block", {
						pagination: {
							el: ".card-slider-pagination",
							type: "progressbar",
						},
						spaceBetween: 12,
						slidesPerView: 1.5,
						navigation: {
							nextEl: ".catalog-swiper-btn-next",
							prevEl: ".catalog-swiper-btn-prev",
						},
						breakpoints: {
							768: {
								slidesPerView: 3.5,
							},
							1024: {
								slidesPerView: 4.5
							},
							1280: {
								slidesPerView: 5.5
							}
						}
					});
				} else {
					// Отложенное обновление Swiper через 100 мс
					setTimeout(() => {
						if (window.catalogSwiperInstance) {
							window.catalogSwiperInstance.update();
						}
					}, 100);
				}
			} else if (window.catalogSwiperInstance) {
				// Отложенное уничтожение Swiper через 100 мс
				setTimeout(() => {
					if (window.catalogSwiperInstance && document.querySelector('.card-slider-block')) {
						window.catalogSwiperInstance.destroy(true, true);
						window.catalogSwiperInstance = null;
					}
				}, 100);
			}
		}
	}

	// Инициализация при загрузке страницы
	window.addEventListener('load', initializeCatalogSwiper);
	// Инициализация при изменении размера окна
	window.addEventListener('resize', initializeCatalogSwiper);
	// Инициализация при смене ориентации экрана
	window.addEventListener('orientationchange', initializeCatalogSwiper);
});
//catalog slider//

//example slider//
$(document).ready(function() {
	function initializeExampleSwiper() {
		if (document.querySelector('.example-slider')) {
			if (window.innerWidth >= 768) {
				if (!window.exampleSwiperInstance) {
					// Инициализация Swiper
					window.exampleSwiperInstance = new Swiper(".example-slider", {
						navigation: {
							nextEl: ".example-slider-btn-next",
							prevEl: ".example-slider-btn-prev",
						},
						spaceBetween: 12,
						slidesPerView: 1.5,
						breakpoints: {
							768: {
								slidesPerView: 3.5,
							},
							1024: {
								slidesPerView: 4.5
							},
							1280: {
								slidesPerView: 5.5
							}
						}
					});
				} else {
					// Отложенное обновление Swiper через 100 мс
					setTimeout(() => {
						if (window.exampleSwiperInstance) {
							window.exampleSwiperInstance.update();
						}
					}, 100);
				}
			} else if (window.exampleSwiperInstance) {
				// Отложенное уничтожение Swiper через 100 мс
				setTimeout(() => {
					if (window.exampleSwiperInstance && document.querySelector('.example-slider')) {
						window.exampleSwiperInstance.destroy(true, true);
						window.exampleSwiperInstance = null;
					}
				}, 100);
			}
		}
	}

	// Инициализация при загрузке страницы
	window.addEventListener('load', initializeExampleSwiper);
	// Инициализация при изменении размера окна
	window.addEventListener('resize', initializeExampleSwiper);
	// Инициализация при смене ориентации экрана
	window.addEventListener('orientationchange', initializeExampleSwiper);
});
//example slider//

//reviews slider//
var swiper = new Swiper(".reviews-slider", {
	pagination: {
		el: ".reviews-pagination",
		type: "progressbar",
	},
	spaceBetween: 12,
	navigation: {
		nextEl: ".reviews-slider-btn-next",
		prevEl: ".reviews-slider-btn-prev",
	},
	breakpoints: {
		480: {
			slidesPerView: 2
		},
		768: {
			slidesPerView: 3.5
		},
		1280: {
			slidesPerView: 5
		}
	}
});
//reviews slider//

//steps-slider//
var swiper = new Swiper(".steps-slider", {
	pagination: {
		el: ".steps-pagination",
		type: "fraction",
	},
	spaceBetween: 12,
	navigation: {
		nextEl: ".steps-btn-next",
		prevEl: ".steps-btn-prev",
	},
	//- breakpoints: {
	//- 	480: {
	//- 		slidesPerView: 2
	//- 	},
	//- 	768: {
	//- 		slidesPerView: 3.5
	//- 	},
	//- 	1280: {
	//- 		slidesPerView: 5
	//- 	}
	//- }
});
//steps-slider//

//slider-image//
var swiper = new Swiper(".slider-image-swiper", {
	pagination: {
		el: ".reviews-pagination",
		type: "progressbar",
	},
	spaceBetween: 12,
	slidesPerView: 1,
	navigation: {
		nextEl: ".slider-image-slider-btn-next",
		prevEl: ".slider-image-slider-btn-prev",
	},
	breakpoints: {
		480: {
			slidesPerView: 1.5
		},
		768: {
			slidesPerView: 3.5
		},
		1280: {
			slidesPerView: 4.5
		}
	}
});
//slider-image//

//phone-mask - маска телефона для всех форм//
$(document).ready(function() {
	// Маска телефона +7 (999) 999-99-99
	function phoneMask(input) {
		input.addEventListener('focus', function() {
			if (this.value === '') {
				this.value = '+7 (';
			}
		});

		input.addEventListener('input', function(e) {
			var val = this.value.replace(/\D/g, '');
			// Ограничиваем до 11 цифр (7 + 10 цифр номера)
			if (val.length > 11) {
				val = val.substring(0, 11);
			}
			var formatted = '';

			if (val.length === 0) {
				formatted = '+7 (';
			} else if (val.length <= 1) {
				formatted = '+7 (';
			} else if (val.length <= 4) {
				formatted = '+7 (' + val.substring(1);
			} else if (val.length <= 7) {
				formatted = '+7 (' + val.substring(1, 4) + ') ' + val.substring(4);
			} else if (val.length <= 9) {
				formatted = '+7 (' + val.substring(1, 4) + ') ' + val.substring(4, 7) + '-' + val.substring(7);
			} else {
				formatted = '+7 (' + val.substring(1, 4) + ') ' + val.substring(4, 7) + '-' + val.substring(7, 9) + '-' + val.substring(9, 11);
			}

			this.value = formatted;
		});

		input.addEventListener('keydown', function(e) {
			// Разрешаем Backspace, Delete, Tab, Escape, стрелки
			if ([8, 46, 9, 27, 37, 38, 39, 40].indexOf(e.keyCode) !== -1) {
				// При Backspace не даём удалить "+7 ("
				if (e.keyCode === 8 && this.value.length <= 4) {
					e.preventDefault();
				}
				return;
			}
			// Разрешаем Ctrl+A, Ctrl+C, Ctrl+V
			if ((e.ctrlKey || e.metaKey) && [65, 67, 86].indexOf(e.keyCode) !== -1) {
				return;
			}
			// Блокируем всё кроме цифр
			if ((e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105)) {
				e.preventDefault();
				return;
			}
			// Блокируем ввод если уже 11 цифр (маска заполнена полностью)
			var currentDigits = this.value.replace(/\D/g, '');
			if (currentDigits.length >= 11) {
				e.preventDefault();
			}
		});

		input.addEventListener('blur', function() {
			if (this.value === '+7 (' || this.value === '+7 ' || this.value === '+7') {
				this.value = '';
			}
		});
	}

	// Инициализация маски на всех телефонных инпутах
	document.querySelectorAll('input[type="tel"]').forEach(function(input) {
		phoneMask(input);
	});

	// Валидация форм: имя и телефон обязательны
	document.querySelectorAll('#formCons, #formCooperation').forEach(function(form) {
		form.addEventListener('submit', function(e) {
			var nameInput = form.querySelector('input[name="STR_NAME"]');
			var phoneInput = form.querySelector('input[name="STR_PHONE"]');
			var phoneDigits = phoneInput ? phoneInput.value.replace(/\D/g, '') : '';

			if (nameInput && nameInput.value.trim() === '') {
				e.preventDefault();
				nameInput.focus();
				return false;
			}

			if (phoneDigits.length !== 11) {
				e.preventDefault();
				if (phoneInput) {
					phoneInput.focus();
					phoneInput.classList.add('form-cons__input--error');
					setTimeout(function() { phoneInput.classList.remove('form-cons__input--error'); }, 2000);
				}
				return false;
			}
		});
	});
});
//phone-mask//

//textarea-autosize - авто-расширение textarea при вводе текста//
$(document).ready(function() {
	document.querySelectorAll('.form-cons__textarea').forEach(function(textarea) {
		function autoResize() {
			textarea.style.height = 'auto';
			textarea.style.height = textarea.scrollHeight + 'px';
		}
		textarea.addEventListener('input', autoResize);
	});
});
//textarea-autosize//

//form-cons - заполняем скрытое поле STR_PAGE текущей страницей//
$(document).ready(function() {
	document.querySelectorAll('input[name="STR_PAGE"]').forEach(function(input) {
		input.value = document.title + ' | ' + window.location.pathname;
	});
});

//form-cons - перехватываем клик по кнопкам и открываем попап//
$(document).ready(function() {
	var popupCons = document.getElementById('popupCons');
	if (!popupCons) return;

	// Функция открытия попапа
	function openPopupCons(triggerEl) {
		// Определяем источник (блок, из которого нажали)
		var section = triggerEl.closest('section');
		var source = '';
		if (section) {
			var heading = section.querySelector('h1, h2, h3');
			if (heading) {
				source = heading.textContent.trim();
			} else {
				source = section.className.split(' ')[0] || 'unknown';
			}
		}

		// Заполняем скрытые поля попапа
		var popupForm = document.getElementById('formPopupCons');
		if (popupForm) {
			var sourceInput = popupForm.querySelector('input[name="STR_SOURCE"]');
			if (sourceInput) sourceInput.value = source;
			var pageInput = popupForm.querySelector('input[name="STR_PAGE"]');
			if (pageInput) pageInput.value = document.title + ' | ' + window.location.pathname;
		}

		// Также обновляем скрытое поле нижней формы (на всякий случай)
		var bottomSourceInput = document.querySelector('#formCons input[name="STR_SOURCE"]');
		if (bottomSourceInput) bottomSourceInput.value = source;

		// Открываем попап
		popupCons.classList.add('active');
		document.body.classList.add('no-scroll');
	}

	// Delegation also handles catalog cards loaded after the initial render.
	document.addEventListener('click', function(e) {
		var trigger = e.target.closest('a[href="#form-cons"], button[data-modal="modal-order"], button[data-modal="modal-price"]');
		if (!trigger) return;
		e.preventDefault();
		openPopupCons(trigger);
	});

	// Закрытие попапа по крестику
	popupCons.querySelector('.popup-cons__close').addEventListener('click', function() {
		closePopupCons();
	});

	// Закрытие попапа по клику на оверлей
	popupCons.querySelector('.popup-cons__overlay').addEventListener('click', function() {
		closePopupCons();
	});

	// Закрытие попапа по Escape
	document.addEventListener('keydown', function(e) {
		if (e.key === 'Escape' && popupCons.classList.contains('active')) {
			closePopupCons();
		}
	});

	function closePopupCons() {
		popupCons.classList.remove('active');
		document.body.classList.remove('no-scroll');
	}
});

//form-cons - отправка формы консультации//
$(document).ready(function() {
	var formCons = document.getElementById('formCons');

	if (formCons) {
		formCons.addEventListener('submit', function(e) {
			e.preventDefault();

			var form = this;
			var submitBtn = form.querySelector('.form-cons__btn');
			var successMsg = form.closest('.form-cons__card').querySelector('.form-cons__success');
			var errorMsg = form.closest('.form-cons__card').querySelector('.form-cons__error');

			// Проверяем телефон перед отправкой
			var phoneInput = form.querySelector('input[name="STR_PHONE"]');
			var phoneDigits = phoneInput ? phoneInput.value.replace(/\D/g, '') : '';
			if (phoneDigits.length !== 11) {
				if (phoneInput) {
					phoneInput.focus();
					phoneInput.classList.add('form-cons__input--error');
					setTimeout(function() { phoneInput.classList.remove('form-cons__input--error'); }, 2000);
				}
				return;
			}

			// Показываем состояние загрузки
			if (submitBtn) {
				submitBtn.classList.add('is-loading');
				submitBtn.textContent = 'ОТПРАВКА...';
			}

			// Скрываем предыдущие сообщения
			if (successMsg) successMsg.style.display = 'none';
			if (errorMsg) errorMsg.remove();

			// Собираем данные формы
			var formData = new FormData(form);

			// Получаем mid из формы или используем значение по умолчанию
			var mid = form.querySelector('input[name="mid"]');
			var midValue = mid ? mid.value : '';

			// Отправляем AJAX запрос
			$.ajax({
				url: '/ajax.php?mid=' + midValue,
				type: 'POST',
				data: formData,
				processData: false,
				contentType: false,
				dataType: 'json',
				success: function(response) {
					if (response.success) {
						// Успех - скрываем всё содержимое карточки кроме success
						var card = form.closest('.form-cons__card');
						if (card) {
							Array.prototype.forEach.call(card.children, function(child) {
								if (!child.classList.contains('form-cons__success')) {
									child.style.display = 'none';
								}
							});
						}
						if (successMsg) {
							successMsg.style.display = 'flex';
						}
						ymGoal('form_submit_cons');
						// Через 6 сек скрываем сообщение и возвращаем форму
						setTimeout(function() {
							if (successMsg) successMsg.style.display = 'none';
							if (card) {
								Array.prototype.forEach.call(card.children, function(child) {
									if (!child.classList.contains('form-cons__success')) {
										child.style.display = '';
									}
								});
							}
							form.reset();
						}, 6000);
					} else {
						// Ошибка - показываем сообщение об ошибке
						var errDiv = document.createElement('div');
						errDiv.className = 'form-cons__error';
						errDiv.innerHTML = '<p>' + (response.error || 'Произошла ошибка') + '</p>';
						form.closest('.form-cons__card').appendChild(errDiv);
					}
				},
				error: function() {
					var errDiv = document.createElement('div');
					errDiv.className = 'form-cons__error';
					errDiv.innerHTML = '<p>Ошибка соединения. Попробуйте позже.</p>';
					form.closest('.form-cons__card').appendChild(errDiv);
				},
				complete: function() {
					// Восстанавливаем кнопку
					if (submitBtn) {
						submitBtn.classList.remove('is-loading');
						submitBtn.textContent = 'ОСТАВИТЬ ЗАЯВКУ';
					}
				}
			});
		});
	}
});
//form-cons//

//popup-cons - отправка формы из попапа//
$(document).ready(function() {
	var formPopup = document.getElementById('formPopupCons');

	if (formPopup) {
		formPopup.addEventListener('submit', function(e) {
			e.preventDefault();

			var form = this;
			var submitBtn = form.querySelector('.popup-cons__btn');
			var card = form.closest('.popup-cons__card');
			var successMsg = card.querySelector('.popup-cons__success');
			var errorMsg = card.querySelector('.popup-cons__error');

			// Проверяем телефон перед отправкой
			var phoneInput = form.querySelector('input[name="STR_PHONE"]');
			var phoneDigits = phoneInput ? phoneInput.value.replace(/\D/g, '') : '';
			if (phoneDigits.length !== 11) {
				if (phoneInput) {
					phoneInput.focus();
					phoneInput.classList.add('popup-cons__input--error');
					setTimeout(function() { phoneInput.classList.remove('popup-cons__input--error'); }, 2000);
				}
				return;
			}

			// Показываем состояние загрузки
			if (submitBtn) {
				submitBtn.classList.add('is-loading');
				submitBtn.textContent = 'ОТПРАВКА...';
			}

			// Скрываем предыдущие сообщения
			if (successMsg) successMsg.style.display = 'none';
			if (errorMsg) errorMsg.remove();

			// Собираем данные формы
			var formData = new FormData(form);

			// Получаем mid из формы
			var mid = form.querySelector('input[name="mid"]');
			var midValue = mid ? mid.value : '';

			// Отправляем AJAX запрос
			$.ajax({
				url: '/ajax.php?mid=' + midValue,
				type: 'POST',
				data: formData,
				processData: false,
				contentType: false,
				dataType: 'json',
				success: function(response) {
					if (response.success) {
						// Успех - скрываем форму, заголовок, текст и показываем сообщение
						form.style.display = 'none';
						var title = card.querySelector('.popup-cons__title');
						if (title) title.style.display = 'none';
						var text = card.querySelector('.popup-cons__text');
						if (text) text.style.display = 'none';
						if (successMsg) {
							successMsg.style.display = 'block';
						}
						ymGoal('form_submit_popup');
						// Через 6 сек скрываем сообщение и возвращаем форму
						setTimeout(function() {
							if (successMsg) successMsg.style.display = 'none';
							form.style.display = '';
							if (title) title.style.display = '';
							if (text) text.style.display = '';
							form.reset();
						}, 6000);
					} else {
						// Ошибка
						var errDiv = document.createElement('div');
						errDiv.className = 'popup-cons__error';
						errDiv.innerHTML = '<p>' + (response.error || 'Произошла ошибка') + '</p>';
						card.appendChild(errDiv);
					}
				},
				error: function() {
					var errDiv = document.createElement('div');
					errDiv.className = 'popup-cons__error';
					errDiv.innerHTML = '<p>Ошибка соединения. Попробуйте позже.</p>';
					card.appendChild(errDiv);
				},
				complete: function() {
					// Восстанавливаем кнопку
					if (submitBtn) {
						submitBtn.classList.remove('is-loading');
						submitBtn.textContent = 'ОСТАВИТЬ ЗАЯВКУ';
					}
				}
			});
		});
	}
});
//popup-cons//

//form-cooperation - отправка формы сотрудничества//
$(document).ready(function() {
	var formCoop = document.getElementById('formCooperation');

	if (formCoop) {
		formCoop.addEventListener('submit', function(e) {
			e.preventDefault();

			var form = this;
			var submitBtn = form.querySelector('.category-infoblock__form-btn');
			var wrapper = form.closest('.category-infoblock__form');
			var successMsg = wrapper ? wrapper.querySelector('.category-infoblock__form-success') : null;
			var licenseMsg = wrapper ? wrapper.querySelector('.category-infoblock__form-license') : null;

			// Показываем состояние загрузки
			if (submitBtn) {
				submitBtn.classList.add('is-loading');
				submitBtn.textContent = 'ОТПРАВКА...';
			}

			// Скрываем предыдущие ошибки
			var oldErr = wrapper ? wrapper.querySelector('.category-infoblock__form-error') : null;
			if (oldErr) oldErr.remove();

			// Собираем данные формы
			var formData = new FormData(form);
			var mid = form.querySelector('input[name="mid"]');
			var midValue = mid ? mid.value : '';

			// Отправляем AJAX запрос
			$.ajax({
				url: '/ajax.php?mid=' + midValue,
				type: 'POST',
				data: formData,
				processData: false,
				contentType: false,
				dataType: 'json',
				success: function(response) {
					if (response.success) {
						form.style.display = 'none';
						if (successMsg) {
							successMsg.style.display = 'flex';
						}
						ymGoal('form_submit_coop');
						// Через 6 сек скрываем сообщение и возвращаем форму
						setTimeout(function() {
							if (successMsg) successMsg.style.display = 'none';
							form.style.display = '';
							form.reset();
						}, 6000);
					} else {
						var errDiv = document.createElement('div');
						errDiv.className = 'category-infoblock__form-error';
						errDiv.style.cssText = 'margin-top:16px;padding:16px;text-align:center;color:red;font-weight:500;';
						errDiv.innerHTML = '<p>' + (response.error || 'Произошла ошибка') + '</p>';
						wrapper.appendChild(errDiv);
					}
				},
				error: function() {
					var errDiv = document.createElement('div');
					errDiv.className = 'category-infoblock__form-error';
					errDiv.style.cssText = 'margin-top:16px;padding:16px;text-align:center;color:red;font-weight:500;';
					errDiv.innerHTML = '<p>Ошибка соединения. Попробуйте позже.</p>';
					wrapper.appendChild(errDiv);
				},
				complete: function() {
					if (submitBtn) {
						submitBtn.classList.remove('is-loading');
						submitBtn.textContent = 'ОТПРАВИТЬ ЗАЯВКУ';
					}
				}
			});
		});
	}
});
//form-cooperation//

//subcategory-nav - показ подкатегорий и кнопка "показать ещё"//
$(document).ready(function() {
	var subcategoryGrid = document.getElementById('subcategoryGrid');
	var loadMoreSubcategoriesBtn = document.getElementById('loadMoreSubcategoriesBtn');

	if (subcategoryGrid) {
		var items = subcategoryGrid.querySelectorAll('.subcategory-nav__item');
		var visibleCount = 0;
		var step = window.innerWidth >= 1440 ? 5 : 4; // 5 в ряд на 1440px+, 4 на остальных

		// Функция показа подкатегорий
		function showSubcategories(count) {
			for (var i = visibleCount; i < Math.min(visibleCount + count, items.length); i++) {
				items[i].classList.add('is-visible');
			}
			visibleCount = Math.min(visibleCount + count, items.length);

			// Скрываем кнопку если все подкатегории показаны
			if (loadMoreSubcategoriesBtn && visibleCount >= items.length) {
				loadMoreSubcategoriesBtn.classList.add('is-hidden');
			}
		}

		// Показываем первые 4 подкатегории при загрузке
		showSubcategories(step);

		// Обработчик клика на кнопку "Показать всё"
		if (loadMoreSubcategoriesBtn) {
			loadMoreSubcategoriesBtn.addEventListener('click', function() {
				showSubcategories(items.length);
			});
		}
	}
});
//subcategory-nav//

//category-catalog - показ карточек и кнопка "загрузить ещё"//
$(document).ready(function() {
	var categoryGrid = document.getElementById('categoryGrid');
	var loadMoreBtn = document.getElementById('loadMoreBtn');

	if (categoryGrid) {
		var moreCat = categoryGrid.getAttribute('data-cat');

		if (moreCat) {
			// === Каталог категории: первые N карточек в HTML, остальные догружаем AJAX-ом ===
			// Первая партия уже отрендерена сервером — показываем и инициализируем слайдеры
			categoryGrid.querySelectorAll('.category-catalog__card').forEach(function(card) {
				card.classList.add('is-visible');
			});
			initSubcategorySlidersInRange();

			var moreTotal = parseInt(categoryGrid.getAttribute('data-total'), 10) || 0;
			var moreOffset = categoryGrid.querySelectorAll('.category-catalog__card').length;
			var moreLoading = false;

			if (loadMoreBtn && moreOffset >= moreTotal) {
				loadMoreBtn.classList.add('is-hidden');
			}

			if (loadMoreBtn) {
				loadMoreBtn.addEventListener('click', function() {
					if (moreLoading || moreOffset >= moreTotal) return;
					moreLoading = true;
					loadMoreBtn.classList.add('is-loading');
					fetch('/catalog_more.php?cat=' + encodeURIComponent(moreCat) + '&offset=' + moreOffset)
						.then(function(r) { return r.ok ? r.text() : ''; })
						.then(function(html) {
							var tmp = document.createElement('div');
							tmp.innerHTML = (html || '').trim();
							var newCards = tmp.querySelectorAll('.category-catalog__card');
							newCards.forEach(function(card) {
								categoryGrid.appendChild(card);
								card.classList.add('is-visible');
								moreOffset++;
							});
							initSubcategorySlidersInRange();
							if (moreOffset >= moreTotal || newCards.length === 0) {
								loadMoreBtn.classList.add('is-hidden');
							}
						})
						.catch(function() {})
						.then(function() {
							moreLoading = false;
							loadMoreBtn.classList.remove('is-loading');
						});
				});
			}
		} else {
			// === Модульные карточки (спецстраницы): прежний клиентский показ по партиям ===
			var cards = categoryGrid.querySelectorAll('.category-catalog__card');
			var visibleCount = 0;
			var step = window.innerWidth >= 1680 ? 5 : 4;

			function showCards(count) {
				for (var i = visibleCount; i < Math.min(visibleCount + count, cards.length); i++) {
					cards[i].classList.add('is-visible');
				}
				visibleCount = Math.min(visibleCount + count, cards.length);

				if (loadMoreBtn && visibleCount >= cards.length) {
					loadMoreBtn.classList.add('is-hidden');
				}

				initSubcategorySlidersInRange(visibleCount - count, visibleCount);
			}

			showCards(4); // по ТЗ: портфолио по 4 карточки

			if (loadMoreBtn) {
				loadMoreBtn.addEventListener('click', function() {
					showCards(4);
				});
			}
		}
	}

	// Инициализация мини-слайдеров в карточках товаров
	function initSubcategorySlidersInRange(start, end) {
		var sliders = document.querySelectorAll('[data-product-slider]');
		sliders.forEach(function(slider) {
			var card = slider.closest('.category-catalog__card');
			if (card && card.classList.contains('is-visible') && !slider.classList.contains('swiper-initialized')) {
				var paginationEl = card.querySelector('.category-slider-pagination');
				var swInst = new Swiper(slider, {
					slidesPerView: 1,
					spaceBetween: 0,
					loop: true,
					pagination: { el: paginationEl, clickable: true }
				});
				// При смене слайда останавливаем видео
				swInst.on('slideChangeTransitionStart', function() {
					slider.querySelectorAll('video').forEach(function(v) {
						v.pause();
						v.closest('.catalog-video-wrap').classList.remove('is-playing');
					});
				});
				// Клик по видео — только play/pause, без нативных controls
				slider.querySelectorAll('.catalog-video-wrap').forEach(function(wrap) {
					var video = wrap.querySelector('video');
					if (!video) return;
					initVideoControls(wrap);
					wrap.addEventListener('click', function(e) {
						e.preventDefault();
						e.stopPropagation();
						if (video.paused) {
							video.play();
							wrap.classList.add('is-playing');
							ymGoal('video_play');
						} else {
							video.pause();
							wrap.classList.remove('is-playing');
						}
					});
				});
			}
		});
	}
});
//category-catalog//

// Кастомные контролы видео в карточках: mute + fullscreen
// Вызывается для каждого .catalog-video-wrap
function initVideoControls(wrap) {
	var video = wrap.querySelector('video');
	if (!video || wrap.querySelector('.catalog-video-controls')) return;

	var controls = document.createElement('div');
	controls.className = 'catalog-video-controls';

	// Кнопка mute/unmute
	var muteBtn = document.createElement('button');
	muteBtn.className = 'catalog-video-btn catalog-video-btn--mute';
	muteBtn.type = 'button';
	muteBtn.setAttribute('aria-label', 'Звук');
	muteBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 5L6 9H2v6h4l5 4V5z" fill="currentColor"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

	// Кнопка fullscreen
	var fsBtn = document.createElement('button');
	fsBtn.className = 'catalog-video-btn catalog-video-btn--fs';
	fsBtn.type = 'button';
	fsBtn.setAttribute('aria-label', 'На весь экран');
	fsBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

	controls.appendChild(muteBtn);
	controls.appendChild(fsBtn);
	wrap.appendChild(controls);

	// Обновляем иконку mute при изменении состояния
	function updateMuteIcon() {
		if (video.muted) {
			muteBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 5L6 9H2v6h4l5 4V5z" fill="currentColor"/><line x1="23" y1="9" x2="17" y2="15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="17" y1="9" x2="23" y2="15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
		} else {
			muteBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 5L6 9H2v6h4l5 4V5z" fill="currentColor"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
		}
	}
	updateMuteIcon();

	muteBtn.addEventListener('click', function(e) {
		e.stopPropagation();
		video.muted = !video.muted;
		updateMuteIcon();
	});

	fsBtn.addEventListener('click', function(e) {
		e.stopPropagation();
		// Используем CSS-оверлей вместо Fullscreen API:
		// CSS-правило `.catalog-video-wrap video::-webkit-media-controls { display:none }`
		// применяется и в fullscreen-режиме, поэтому нативные контролы не видны.
		// Оверлей создаётся вне .catalog-video-wrap — правило на него не распространяется.
		var overlay = document.createElement('div');
		overlay.style.cssText = 'position:fixed;inset:0;z-index:99999;background:#000;display:flex;align-items:center;justify-content:center;touch-action:none;';

		var closeBtn = document.createElement('button');
		closeBtn.type = 'button';
		closeBtn.setAttribute('aria-label', 'Закрыть');
		closeBtn.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 6L6 18M6 6l12 12" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
		closeBtn.style.cssText = 'position:absolute;top:12px;right:12px;background:rgba(0,0,0,.6);border:none;border-radius:50%;width:40px;height:40px;display:flex;align-items:center;justify-content:center;cursor:pointer;z-index:1;padding:0;-webkit-tap-highlight-color:transparent;';

		var fsVideo = document.createElement('video');
		var source = video.querySelector('source');
		var rawSrc = source ? source.getAttribute('src') : video.getAttribute('src');
		rawSrc = rawSrc ? rawSrc.replace(/#.*$/, '') : ''; // убираем #t=0.5
		fsVideo.setAttribute('src', rawSrc);
		fsVideo.setAttribute('controls', '');
		fsVideo.setAttribute('playsinline', '');
		fsVideo.controls = true;
		fsVideo.muted = video.muted;
		fsVideo.style.cssText = 'max-width:100%;max-height:100vh;width:100%;display:block;background:#000;';
		try { fsVideo.currentTime = video.currentTime || 0; } catch(err) {}

		overlay.appendChild(closeBtn);
		overlay.appendChild(fsVideo);
		document.body.appendChild(overlay);
		document.body.style.overflow = 'hidden';

		// Останавливаем оригинальное видео, чтобы не было двух аудиодорожек
		var wasPlaying = !video.paused;
		video.pause();

		fsVideo.play().catch(function() {});

		function closeOverlay() {
			fsVideo.pause();
			try { video.currentTime = fsVideo.currentTime; } catch(err) {}
			document.body.removeChild(overlay);
			document.body.style.overflow = '';
			document.removeEventListener('keydown', onKeyDown);
			// Возобновляем оригинальное видео, если оно играло до открытия оверлея
			if (wasPlaying) {
				video.play().catch(function() {});
			}
		}

		closeBtn.addEventListener('click', closeOverlay);
		overlay.addEventListener('click', function(ev) {
			if (ev.target === overlay) closeOverlay();
		});
		var onKeyDown = function(ev) {
			if (ev.key === 'Escape' || ev.keyCode === 27) closeOverlay();
		};
		document.addEventListener('keydown', onKeyDown);

		// Свайп вниз для закрытия
		var swipeStartY = 0;
		var swipeStartX = 0;
		var swiping = false;
		var SWIPE_THRESHOLD = 80;

		overlay.addEventListener('touchstart', function(ev) {
			if (ev.touches.length !== 1) return;
			swipeStartY = ev.touches[0].clientY;
			swipeStartX = ev.touches[0].clientX;
			swiping = false;
		}, { passive: true });

		overlay.addEventListener('touchmove', function(ev) {
			if (ev.touches.length !== 1) return;
			var dy = ev.touches[0].clientY - swipeStartY;
			var dx = ev.touches[0].clientX - swipeStartX;
			// Активируем только при преимущественно вертикальном движении вниз
			if (!swiping && dy > 10 && Math.abs(dy) > Math.abs(dx)) {
				swiping = true;
			}
			if (!swiping || dy <= 0) return;
			// Тянем видео вниз и затемняем фон
			fsVideo.style.transform = 'translateY(' + dy + 'px)';
			overlay.style.background = 'rgba(0,0,0,' + Math.max(0.15, 1 - dy / 250) + ')';
		}, { passive: true });

		overlay.addEventListener('touchend', function(ev) {
			if (!swiping) return;
			swiping = false;
			var dy = ev.changedTouches[0].clientY - swipeStartY;
			if (dy >= SWIPE_THRESHOLD) {
				// Порог преодолён — анимируем уход и закрываем
				fsVideo.style.transition = 'transform 0.2s ease';
				fsVideo.style.transform = 'translateY(110%)';
				overlay.style.transition = 'opacity 0.2s ease';
				overlay.style.opacity = '0';
				setTimeout(closeOverlay, 200);
			} else {
				// Не хватило — возвращаем на место
				fsVideo.style.transition = 'transform 0.25s ease';
				fsVideo.style.transform = '';
				overlay.style.background = '#000';
				setTimeout(function() { fsVideo.style.transition = ''; }, 250);
			}
		}, { passive: true });
	});
}

//infoblock-cards - показ карточек инфоблоков и кнопка "загрузить ещё"//
$(document).ready(function() {
	var cardsGrids = document.querySelectorAll('[data-cards-grid]');

	cardsGrids.forEach(function(grid) {
		var gridName = grid.getAttribute('data-cards-grid');
		var cards = grid.querySelectorAll('.category-catalog__card');
		var loadMoreBtn = document.querySelector('[data-load-more="' + gridName + '"]');
		var visibleCount = 0;
		var step = window.innerWidth >= 1680 ? 5 : 4;

		function showCards(count) {
			for (var i = visibleCount; i < Math.min(visibleCount + count, cards.length); i++) {
				cards[i].classList.add('is-visible');
			}
			visibleCount = Math.min(visibleCount + count, cards.length);

			if (loadMoreBtn) {
				if (visibleCount >= cards.length) {
					loadMoreBtn.classList.add('is-hidden');
				} else {
					loadMoreBtn.classList.remove('is-hidden');
				}
			}

			// Инициализируем слайдеры для новых видимых карточек
			initInfoblockCardSliders();
		}

		var isMobile = window.innerWidth < 1024;
		var mobileStep = gridName === 'salon' ? 6 : 2;
		showCards(isMobile ? mobileStep : step * 2);

		if (loadMoreBtn) {
			loadMoreBtn.addEventListener('click', function() {
				showCards(isMobile ? mobileStep : step);
			});
		}
	});

	// Инициализация мини-слайдеров в карточках инфоблоков
	function initInfoblockCardSliders() {
		var sliders = document.querySelectorAll('[data-cards-grid] [data-product-slider]');
		sliders.forEach(function(slider) {
			var card = slider.closest('.category-catalog__card');
			if (card && card.classList.contains('is-visible') && !slider.classList.contains('swiper-initialized')) {
				var paginationEl = card.querySelector('.category-slider-pagination');
				var swInst = new Swiper(slider, {
					slidesPerView: 1,
					spaceBetween: 0,
					loop: true,
					pagination: { el: paginationEl, clickable: true }
				});
				// При смене слайда останавливаем видео
				swInst.on('slideChangeTransitionStart', function() {
					slider.querySelectorAll('video').forEach(function(v) {
						v.pause();
						v.closest('.catalog-video-wrap').classList.remove('is-playing');
					});
				});
				// Клик по видео — только play/pause, без нативных controls
				slider.querySelectorAll('.catalog-video-wrap').forEach(function(wrap) {
					var video = wrap.querySelector('video');
					if (!video) return;
					initVideoControls(wrap);
					wrap.addEventListener('click', function(e) {
						e.preventDefault();
						e.stopPropagation();
						if (video.paused) {
							video.play();
							wrap.classList.add('is-playing');
							ymGoal('video_play');
						} else {
							video.pause();
							wrap.classList.remove('is-playing');
						}
					});
				});
			}
		});
	}
});
//infoblock-cards//

//product-equip-grids - показ карточек комплектации/доп.блоков на странице товара и кнопка "загрузить ещё"//
$(document).ready(function() {
	var equipGrids = document.querySelectorAll('[data-equip-grid]');

	equipGrids.forEach(function(grid) {
		var gridName = grid.getAttribute('data-equip-grid');
		var cards = grid.querySelectorAll('.category-catalog__card');
		var loadMoreBtn = document.querySelector('[data-equip-more="' + gridName + '"]');
		var visibleCount = 0;
		var step = 6;

		function showCards(count) {
			for (var i = visibleCount; i < Math.min(visibleCount + count, cards.length); i++) {
				cards[i].classList.add('is-visible');
			}
			visibleCount = Math.min(visibleCount + count, cards.length);

			if (loadMoreBtn && visibleCount >= cards.length) {
				loadMoreBtn.classList.add('is-hidden');
			}
		}

		showCards(step);

		if (loadMoreBtn) {
			loadMoreBtn.addEventListener('click', function() {
				showCards(step);
			});
		}
	});
});
//product-equip-grids//

//category-blog - показ статей блога и кнопка "загрузить ещё"//
$(document).ready(function() {
	var blogGrid = document.getElementById('blogGrid');
	var loadMoreBlogBtn = document.getElementById('loadMoreBlogBtn');

	if (blogGrid) {
		var cards = blogGrid.querySelectorAll('.category-blog__card');
		var visibleCount = 0;
		var step = window.innerWidth >= 1680 ? 5 : 4;

		// Функция показа карточек
		function showBlogCards(count) {
			for (var i = visibleCount; i < Math.min(visibleCount + count, cards.length); i++) {
				cards[i].classList.add('is-visible');
			}
			visibleCount = Math.min(visibleCount + count, cards.length);

			// Скрываем/показываем кнопку в зависимости от кол-ва карточек
			if (loadMoreBlogBtn) {
				if (visibleCount >= cards.length) {
					loadMoreBlogBtn.classList.add('is-hidden');
				} else {
					loadMoreBlogBtn.classList.remove('is-hidden');
				}
			}
		}

		// На мобильных показываем 2 статьи, на десктопе — 2 ряда
		var isMobile = window.innerWidth < 1024;
		showBlogCards(isMobile ? 2 : step * 2);

		// Обработчик клика на кнопку "Загрузить ещё"
		if (loadMoreBlogBtn) {
			loadMoreBlogBtn.addEventListener('click', function() {
				showBlogCards(isMobile ? 2 : step);
			});
		}
	}
});
//category-blog//

//category-faq - ограничение вывода на мобильных (показываем 4, остальные по клику)//
$(document).ready(function() {
	if (window.innerWidth >= 1024) return;

	var faqList = document.querySelector('.category-faq__list');
	var loadMoreFaqBtn = document.getElementById('loadMoreFaqBtn');

	if (!faqList) return;

	var items = faqList.querySelectorAll('.category-faq__item');
	var visibleCount = 4;
	var step = 4;

	// Скрываем элементы после 4-го
	for (var i = visibleCount; i < items.length; i++) {
		items[i].style.display = 'none';
	}

	// Если все показаны — скрываем кнопку
	if (loadMoreFaqBtn && items.length <= visibleCount) {
		loadMoreFaqBtn.closest('.category-faq__load-more').classList.add('is-hidden');
	}

	if (loadMoreFaqBtn) {
		loadMoreFaqBtn.addEventListener('click', function() {
			var end = Math.min(visibleCount + step, items.length);
			for (var i = visibleCount; i < end; i++) {
				items[i].style.display = '';
			}
			visibleCount = end;
			if (visibleCount >= items.length) {
				loadMoreFaqBtn.closest('.category-faq__load-more').classList.add('is-hidden');
			}
		});
	}
});
//category-faq//

//category-designers - ограничение вывода на мобильных (показываем 2, остальные по клику)//
$(document).ready(function() {
	if (window.innerWidth >= 1024) return;

	var designersList = document.querySelector('.category-designers__list');
	var loadMoreDesignersBtn = document.getElementById('loadMoreDesignersBtn');

	if (!designersList) return;

	// Блок --steps обрабатывается отдельным скриптом ниже
	if (designersList.closest('.category-designers--steps')) return;

	var items = designersList.querySelectorAll('.category-designers__card');
	var visibleCount = 2;
	var step = 2;

	// Скрываем карточки после 2-й
	for (var i = visibleCount; i < items.length; i++) {
		items[i].style.display = 'none';
	}

	// Если все показаны — скрываем кнопку
	if (loadMoreDesignersBtn && items.length <= visibleCount) {
		loadMoreDesignersBtn.closest('.category-designers__load-more').classList.add('is-hidden');
	}

	if (loadMoreDesignersBtn) {
		loadMoreDesignersBtn.addEventListener('click', function() {
			var end = Math.min(visibleCount + step, items.length);
			for (var i = visibleCount; i < end; i++) {
				items[i].style.display = '';
			}
			visibleCount = end;
			if (visibleCount >= items.length) {
				loadMoreDesignersBtn.closest('.category-designers__load-more').classList.add('is-hidden');
			}
		});
	}
});
//category-designers//

//category-designers-steps - показываем 6 карточек на всех устройствах//
$(document).ready(function() {
	var stepsBlock = document.querySelector('.category-designers--steps');
	if (!stepsBlock) return;

	var designersList = stepsBlock.querySelector('.category-designers__list');
	var loadMoreBtn = stepsBlock.querySelector('#loadMoreDesignersBtn');

	if (!designersList) return;

	var items = designersList.querySelectorAll('.category-designers__card');
	var visibleCount = 6;
	var step = 6;

	// Скрываем карточки после 6-й
	for (var i = visibleCount; i < items.length; i++) {
		items[i].style.display = 'none';
	}

	// Если карточек не больше 6 — скрываем кнопку
	if (loadMoreBtn && items.length <= visibleCount) {
		loadMoreBtn.closest('.category-designers__load-more').classList.add('is-hidden');
	}

	if (loadMoreBtn) {
		loadMoreBtn.addEventListener('click', function() {
			var end = Math.min(visibleCount + step, items.length);
			for (var i = visibleCount; i < end; i++) {
				items[i].style.display = '';
			}
			visibleCount = end;
			if (visibleCount >= items.length) {
				loadMoreBtn.closest('.category-designers__load-more').classList.add('is-hidden');
			}
		});
	}
});
//category-designers-steps//

//category-works - показ карточек "Наши работы" и кнопка "загрузить ещё"//
$(document).ready(function() {
	var worksGrid = document.getElementById('worksGrid');
	var loadMoreWorksBtn = document.getElementById('loadMoreWorksBtn');

	if (worksGrid) {
		var cards = worksGrid.querySelectorAll('.category-works__card');
		var visibleCount = 0;
		var step = window.innerWidth >= 1680 ? 5 : 4;

		// Функция показа карточек
		function showWorksCards(count) {
			for (var i = visibleCount; i < Math.min(visibleCount + count, cards.length); i++) {
				cards[i].classList.add('is-visible');
			}
			visibleCount = Math.min(visibleCount + count, cards.length);

			// Скрываем кнопку если все карточки показаны
			if (loadMoreWorksBtn && visibleCount >= cards.length) {
				loadMoreWorksBtn.classList.add('is-hidden');
			}

			// Инициализируем слайдеры для новых видимых карточек
			initWorksSlidersInRange(visibleCount - count, visibleCount);
		}

		// Показываем первые 2 ряда карточек при загрузке
		showWorksCards(step * 2);

		// Обработчик клика на кнопку "Загрузить ещё"
		if (loadMoreWorksBtn) {
			loadMoreWorksBtn.addEventListener('click', function() {
				showWorksCards(step);
			});
		}
	}

	// Инициализация мини-слайдеров в карточках "Наши работы"
	function initWorksSlidersInRange(start, end) {
		var sliders = document.querySelectorAll('[data-works-slider]');
		sliders.forEach(function(slider) {
			var card = slider.closest('.category-works__card');
			if (card && card.classList.contains('is-visible') && !slider.classList.contains('swiper-initialized')) {
				var paginationEl = card.querySelector('.category-slider-pagination');
				new Swiper(slider, {
					slidesPerView: 1,
					spaceBetween: 0,
					loop: true,
					pagination: {
						el: paginationEl,
						clickable: true
					}
				});
				// Обработка клика по видео — аналогично catalog/infoblock
				slider.querySelectorAll('.catalog-video-wrap').forEach(function(wrap) {
					var video = wrap.querySelector('video');
					if (!video) return;
					initVideoControls(wrap);
					wrap.addEventListener('click', function(e) {
						e.preventDefault();
						e.stopPropagation();
						if (video.paused) {
							video.play();
							wrap.classList.add('is-playing');
							ymGoal('video_play');
						} else {
							video.pause();
							wrap.classList.remove('is-playing');
						}
					});
				});
			}
		});
	}
});
//category-works//

//category-infoblock - слайдеры медиа в блоках InfoBlock (Салон, Выезд замерщика, Своё производство, Сборка и установка)//
$(document).ready(function() {
	var infoblockSliders = document.querySelectorAll('[data-infoblock-slider]');
	infoblockSliders.forEach(function(slider) {
		if (!slider.classList.contains('swiper-initialized')) {
			// Создаём элемент пагинации внутри swiper-контейнера
			var paginationEl = document.createElement('div');
			paginationEl.className = 'category-slider-pagination';
			slider.appendChild(paginationEl);

			// Находим контейнеры с текстами над и под фото
			var media = slider.closest('.category-infoblock__media');
			var topTexts = media ? media.querySelectorAll('.category-infoblock__slide-top') : [];
			var bottomTexts = media ? media.querySelectorAll('.category-infoblock__slide-bottom') : [];

			new Swiper(slider, {
				slidesPerView: 1,
				spaceBetween: 0,
				loop: true,
				pagination: {
					el: paginationEl,
					clickable: true
				},
				on: {
					slideChange: function() {
						if (topTexts.length > 0) {
							topTexts.forEach(function(el) { el.style.display = 'none'; });
							if (topTexts[this.realIndex]) {
								topTexts[this.realIndex].style.display = 'block';
							}
						}
						if (bottomTexts.length > 0) {
							bottomTexts.forEach(function(el) { el.style.display = 'none'; });
							if (bottomTexts[this.realIndex]) {
								bottomTexts[this.realIndex].style.display = 'block';
							}
						}
					}
				}
			});
		}
	});
});
//category-infoblock//

//category-reviews - показ отзывов и кнопка "загрузить ещё"//
$(document).ready(function() {
	var reviewsList = document.getElementById('categoryReviewsList');
	var loadMoreReviewsBtn = document.getElementById('loadMoreReviewsBtn');

	if (reviewsList) {
		var reviews = reviewsList.querySelectorAll('.category-reviews__item');
		var visibleCount = 0;
		var step = 2; // Показываем по 2 отзыва

		// Функция показа отзывов
		function showReviews(count) {
			for (var i = visibleCount; i < Math.min(visibleCount + count, reviews.length); i++) {
				reviews[i].classList.add('is-visible');
				// Инициализируем слайдеры для новых видимых отзывов
				initReviewSlidersInItem(reviews[i]);
			}
			visibleCount = Math.min(visibleCount + count, reviews.length);

			// Скрываем кнопку если все отзывы показаны
			if (loadMoreReviewsBtn && visibleCount >= reviews.length) {
				loadMoreReviewsBtn.classList.add('is-hidden');
			}
		}

		// Инициализация слайдера внутри отзыва
		function initReviewSlidersInItem(item) {
			var slider = item.querySelector('[data-review-slider]');
			if (slider && !slider.classList.contains('swiper-initialized')) {
				// Создаём элемент пагинации внутри swiper-контейнера
				var paginationEl = document.createElement('div');
				paginationEl.className = 'category-slider-pagination';
				slider.appendChild(paginationEl);

				new Swiper(slider, {
					slidesPerView: 1,
					spaceBetween: 0,
					loop: true,
					pagination: {
						el: paginationEl,
						clickable: true
					}
				});
			}
		}

		// Показываем первые 2 отзыва при загрузке
		showReviews(step);

		// Обработчик клика на кнопку "Загрузить ещё"
		if (loadMoreReviewsBtn) {
			loadMoreReviewsBtn.addEventListener('click', function() {
				showReviews(step);
			});
		}
	}
});
//category-reviews//

//Fancybox - полноэкранный просмотр изображений//
// Библиотека (~140 КБ) грузится по первому клику по [data-fancybox], а не на каждой странице:
// клик перехватывается, скрипт подгружается, затем клик повторяется и галерея открывается.
(function() {
	var FANCYBOX_SRC = '/assets/dist/fancybox.umd.js';
	var state = typeof Fancybox !== 'undefined' ? 'ready' : 'idle'; // idle | loading | ready

	function bindFancybox() {
		Fancybox.bind('[data-fancybox]', {
			on: {
				ready: function() {
					ymGoal('gallery_open');
				}
			},
			// Опции галереи
			Carousel: {
				infinite: true
			},
			Thumbs: {
				type: 'classic'
			},
			Toolbar: {
				display: {
					left: ['infobar'],
					middle: [],
					right: ['iterateZoom', 'slideshow', 'fullscreen', 'download', 'thumbs', 'close']
				}
			}
		});
	}

	if (state === 'ready') {
		bindFancybox();
	}

	document.addEventListener('click', function(e) {
		if (state === 'ready') return;
		var link = e.target.closest ? e.target.closest('[data-fancybox]') : null;
		if (!link) return;
		e.preventDefault();
		e.stopPropagation();
		if (state === 'loading') return;
		state = 'loading';
		var script = document.createElement('script');
		script.src = FANCYBOX_SRC;
		script.onload = function() {
			state = 'ready';
			bindFancybox();
			link.click();
		};
		script.onerror = function() {
			state = 'idle';
			if (link.href) window.location.href = link.href;
		};
		document.head.appendChild(script);
	}, true);
})();
//Fancybox//

//category-faq - аккордеон вопрос-ответ//
$(document).ready(function() {
	document.querySelectorAll('[data-faq-toggle]').forEach(function(question) {
		question.addEventListener('click', function() {
			var item = this.closest('.category-faq__item');
			if (item) {
				item.classList.toggle('is-open');
			}
		});
	});
});
//category-faq//

//category-detail-btn - кнопка "Подробнее" для раскрытия полного описания//
$(document).ready(function() {
	document.querySelectorAll('[data-toggle-detail]').forEach(function(btn) {
		btn.addEventListener('click', function() {
			var fullDesc = this.previousElementSibling;
			var self = this;
			if (fullDesc && fullDesc.style.display === 'none') {
				// Запоминаем позицию кнопки относительно viewport перед раскрытием
				self._savedOffsetTop = self.getBoundingClientRect().top;
				fullDesc.style.display = 'block';
				this.textContent = 'Свернуть';
			} else if (fullDesc) {
				fullDesc.style.display = 'none';
				self.textContent = 'Подробнее';
				// Восстанавливаем позицию кнопки в viewport как было до раскрытия
				var savedTop = self._savedOffsetTop;
				if (savedTop !== undefined) {
					var currentTop = self.getBoundingClientRect().top;
					var diff = currentTop - savedTop;
					window.scrollBy({ top: diff, behavior: 'smooth' });
				}
			}
		});
	});
});
//category-detail-btn//

//video-poster-click - клик по превью видео запускает воспроизведение//
$(document).ready(function() {
	var mainSlides = document.querySelectorAll('.product-media__slider .swiper-slide');
	var thumbSlides = document.querySelectorAll('.product-media__thumbs .swiper-slide');

	document.querySelectorAll('.product-media__video').forEach(function(container) {
		var poster = container.querySelector('.product-media__video-poster');
		var playBtn = container.querySelector('.product-media__video-play');
		var video = container.querySelector('video');

		if (video) {
			var startVideo = function(e) {
				e.preventDefault();
				e.stopPropagation();
				container.classList.add('is-playing');
				video.controls = true;
				video.setAttribute('controls', '');
				video.play();
				ymGoal('video_play');
				// Отключаем свайп слайдера — иначе он перехватывает касания по контролам видео
				if (window.productMainSwiper) {
					window.productMainSwiper.allowTouchMove = false;
				}
			};
			// Возвращаем свайп когда видео остановлено или вышли из полного экрана
			video.addEventListener('pause', function() {
				if (window.productMainSwiper) window.productMainSwiper.allowTouchMove = true;
			});
			video.addEventListener('ended', function() {
				if (window.productMainSwiper) window.productMainSwiper.allowTouchMove = true;
			});
			// fullscreenchange стреляет на document (не на video-элементе)
			var onFsChange = function() {
				var fsEl = document.fullscreenElement || document.webkitFullscreenElement;
				if (fsEl === video) {
					// Вошли в полный экран — гарантируем controls (Android Chrome)
					video.controls = true;
					video.setAttribute('controls', '');
				} else {
					// Вышли из полного экрана — возвращаем свайп слайдера
					if (window.productMainSwiper) window.productMainSwiper.allowTouchMove = true;
				}
			};
			document.addEventListener('fullscreenchange', onFsChange);
			document.addEventListener('webkitfullscreenchange', onFsChange);

			// iOS/Safari: webkitbeginfullscreen срабатывает до перехода
			video.addEventListener('webkitbeginfullscreen', function() {
				video.controls = true;
				video.setAttribute('controls', '');
			});

			// Находим индекс этого слайда для связи с миниатюрой
			var slide = container.closest('.swiper-slide');
			var slideIndex = Array.prototype.indexOf.call(mainSlides, slide);

			if (poster) {
				poster.addEventListener('click', startVideo);
			} else {
				// Нет загруженной превью-картинки — генерируем из видео (кадр на 5 сек)
				var genVideo = document.createElement('video');
				genVideo.crossOrigin = 'anonymous';
				genVideo.muted = true;
				genVideo.preload = 'auto';
				genVideo.playsInline = true;
				genVideo.src = video.querySelector('source').getAttribute('src');

				genVideo.addEventListener('loadeddata', function() {
					genVideo.currentTime = 5;
				}, { once: true });

				genVideo.addEventListener('seeked', function() {
					try {
						var canvas = document.createElement('canvas');
						canvas.width = genVideo.videoWidth;
						canvas.height = genVideo.videoHeight;
						canvas.getContext('2d').drawImage(genVideo, 0, 0, canvas.width, canvas.height);
						var dataUrl = canvas.toDataURL('image/jpeg', 0.8);

						// Вставляем превью в основной слайд
						var img = document.createElement('img');
						img.className = 'product-media__video-poster';
						img.src = dataUrl;
						img.alt = 'Превью видео';
						container.insertBefore(img, container.firstChild);
						img.addEventListener('click', startVideo);

						// Вставляем превью в миниатюру
						if (slideIndex >= 0 && thumbSlides[slideIndex]) {
							var thumbVideo = thumbSlides[slideIndex].querySelector('.product-media__thumb-video');
							if (thumbVideo) {
								var thumbPlay = thumbVideo.querySelector('.product-media__thumb-play');
								if (thumbPlay) {
									var thumbImg = document.createElement('img');
									thumbImg.src = dataUrl;
									thumbImg.alt = 'Превью видео';
									thumbVideo.replaceChild(thumbImg, thumbPlay);
								}
							}
						}

						genVideo.src = '';
						genVideo = null;
					} catch (e) {
						// CORS или другая ошибка — показываем видео как есть
						video.controls = true;
					}
				}, { once: true });
			}

			if (playBtn) playBtn.addEventListener('click', startVideo);

			// Если нет превью и генерация не сработает — покажем controls
			if (!poster) {
				video.addEventListener('error', function() {
					video.controls = true;
				});
			}
		}
	});
});
//video-poster-click//

//product-media-slider//
$(document).ready(function() {
	var mainSliderEl = document.querySelector('[data-product-main-slider]');
	var thumbsSliderEl = document.querySelector('[data-product-thumbs-slider]');
	if (mainSliderEl) {
		var thumbsSwiper = null;
		if (thumbsSliderEl) {
			thumbsSwiper = new Swiper(thumbsSliderEl, {
				spaceBetween: 8,
				slidesPerView: 'auto',
				freeMode: true,
				watchSlidesProgress: true,
				watchOverflow: true,
				navigation: {
					nextEl: '.product-media__thumbs-nav--next',
					prevEl: '.product-media__thumbs-nav--prev'
				},
				breakpoints: {
					768: {
						spaceBetween: 10,
						slidesPerView: 'auto'
					},
					1024: {
						spaceBetween: 12,
						slidesPerView: 'auto'
					},
					1440: {
						spaceBetween: 14,
						slidesPerView: 'auto'
					}
				},
				on: {
					init: function() {
						var prevBtn = document.querySelector('.product-media__thumbs-nav--prev');
						var nextBtn = document.querySelector('.product-media__thumbs-nav--next');
						if (prevBtn && nextBtn) {
							if (this.isLocked) {
								prevBtn.style.display = 'none';
								nextBtn.style.display = 'none';
							} else {
								prevBtn.style.display = 'flex';
								nextBtn.style.display = 'flex';
							}
						}
					},
					resize: function() {
						var prevBtn = document.querySelector('.product-media__thumbs-nav--prev');
						var nextBtn = document.querySelector('.product-media__thumbs-nav--next');
						if (prevBtn && nextBtn) {
							if (this.isLocked) {
								prevBtn.style.display = 'none';
								nextBtn.style.display = 'none';
							} else {
								prevBtn.style.display = 'flex';
								nextBtn.style.display = 'flex';
							}
						}
					}
				}
			});
		}
		var mainSwiperConfig = {
			spaceBetween: 0,
			navigation: {
				nextEl: '.product-media__nav-next',
				prevEl: '.product-media__nav-prev'
			}
		};
		if (thumbsSwiper) {
			mainSwiperConfig.thumbs = { swiper: thumbsSwiper };
		}
		// Сохраняем в глобальную переменную, чтобы видео могло отключать свайп
		window.productMainSwiper = new Swiper(mainSliderEl, mainSwiperConfig);
	}
});
//product-media-slider//

//product-content//
$(document).ready(function() {
	// Кнопка «Подробнее» — показ/скрытие полного описания
	$('[data-content-toggle]').on('click', function() {
		var $btn = $(this);
		var $section = $btn.closest('[data-content-section]');
		var $full = $section.find('.product-content__full');
		if ($full.is(':visible')) {
			$full.slideUp(300);
			$btn.text('Подробнее');
		} else {
			$full.slideDown(300);
			$btn.text('Скрыть');
		}
	});


});
//product-content//

//blog-page - табы по категориям и кнопка "Загрузить ещё"//
$(document).ready(function() {
	var grid = document.getElementById('blogPageGrid');
	if (!grid) return;

	var allCards = Array.prototype.slice.call(grid.querySelectorAll('.blog-page__card'));
	var loadMoreBtn = document.getElementById('loadMoreBlogPageBtn');
	var activeTab = 'all';
	var step = 10;
	var visibleCount = 0;

	// Возвращает карточки, подходящие под активный таб
	function getFilteredCards() {
		if (activeTab === 'all') return allCards;
		return allCards.filter(function(card) {
			var ids = (card.getAttribute('data-category') || '').split(',');
			return ids.indexOf(activeTab) !== -1;
		});
	}

	// Показывает следующую порцию карточек
	function showMore() {
		var filtered = getFilteredCards();
		var newCount = Math.min(visibleCount + step, filtered.length);
		for (var i = visibleCount; i < newCount; i++) {
			filtered[i].classList.add('is-visible');
		}
		visibleCount = newCount;
		if (loadMoreBtn) {
			if (visibleCount >= filtered.length) {
				loadMoreBtn.classList.add('is-hidden');
			} else {
				loadMoreBtn.classList.remove('is-hidden');
			}
		}
	}

	// Сбрасывает видимость и показывает первую порцию для текущего фильтра
	function applyFilter() {
		var filtered = getFilteredCards();
		// Скрываем все
		allCards.forEach(function(card) {
			card.classList.remove('is-visible');
			card.classList.remove('is-filtered-out');
		});
		// Помечаем не подходящие под фильтр
		allCards.forEach(function(card) {
			if (filtered.indexOf(card) === -1) {
				card.classList.add('is-filtered-out');
			}
		});
		visibleCount = 0;
		showMore();
	}

	// Табы
	var tabBtns = document.querySelectorAll('.blog-tabs-btn');
	tabBtns.forEach(function(btn) {
		btn.addEventListener('click', function() {
			tabBtns.forEach(function(b) { b.classList.remove('is-active'); });
			btn.classList.add('is-active');
			activeTab = btn.getAttribute('data-tab') || 'all';
			applyFilter();
		});
	});

	// Кнопка "Загрузить ещё"
	if (loadMoreBtn) {
		loadMoreBtn.addEventListener('click', function() {
			showMore();
		});
	}

	// Первичный показ
	applyFilter();
});
//blog-page//

// ========== SECTION SIDE NAV ==========
// Плавающая навигация по блокам — черточки справа.
// Десктоп: тултип при ховере. Мобильные: свайп = показ названия, тап = переход.
(function() {
	var MIN_SECTIONS = 2;

	function getSections() {
		// Основные классы секций на сайте
		var list = Array.prototype.slice.call(
			document.querySelectorAll('section.category-block, section.section-typical')
		);
		// Fallback: ищем любые section с заголовком внутри main
		if (list.length < MIN_SECTIONS) {
			list = Array.prototype.slice.call(
				document.querySelectorAll('main section, .main section')
			).filter(function(s) {
				return s.querySelector('.category-block__title, h2, h3');
			});
		}
		return list;
	}

	function scrollTo(section) {
		var headerH = parseInt(
			getComputedStyle(document.documentElement).getPropertyValue('--header-height')
		) || 80;
		var top = section.getBoundingClientRect().top + window.pageYOffset - headerH - 12;
		window.scrollTo({ top: top, behavior: 'smooth' });
	}

	function init() {
		var sections = getSections();
		if (sections.length < MIN_SECTIONS) return;

		var nav = document.createElement('nav');
		nav.className = 'section-nav';
		nav.setAttribute('aria-label', 'Навигация по разделам');

		var items = sections.map(function(section) {
			var titleEl = section.querySelector('.category-block__title, h2, h3');
			var title = titleEl ? titleEl.textContent.trim() : '';

			var btn = document.createElement('button');
			btn.type = 'button';
			btn.className = 'section-nav__item';
			if (title) btn.setAttribute('aria-label', title);

			var line = document.createElement('span');
			line.className = 'section-nav__line';
			btn.appendChild(line);

			if (title) {
				var tip = document.createElement('span');
				tip.className = 'section-nav__tooltip';
				tip.textContent = title;
				btn.appendChild(tip);
			}

			// Десктоп: клик → переход
			btn.addEventListener('click', function() { scrollTo(section); });

			nav.appendChild(btn);
			return { btn: btn, section: section };
		});

		document.body.appendChild(nav);

		// Активный пункт по скроллу
		function setActive(index) {
			items.forEach(function(item, i) {
				item.btn.classList.toggle('active', i === index);
			});
		}
		setActive(0);

		if ('IntersectionObserver' in window) {
			var obs = new IntersectionObserver(function(entries) {
				entries.forEach(function(entry) {
					if (!entry.isIntersecting) return;
					var i = items.findIndex(function(it) { return it.section === entry.target; });
					if (i !== -1) setActive(i);
				});
			}, { rootMargin: '-15% 0px -75% 0px' });
			items.forEach(function(item) { obs.observe(item.section); });
		}

		// ---- Вибрация: Android (vibrate API) + iOS (checkbox switch hack) ----
		var iosHapticLabel = null;
		if (/iPhone|iPad|iPod/.test(navigator.userAgent)) {
			var iosInput = document.createElement('input');
			iosInput.type = 'checkbox';
			iosInput.setAttribute('switch', '');
			iosInput.style.cssText = 'position:fixed;opacity:.0001;width:1px;height:1px;pointer-events:none;';
			iosHapticLabel = document.createElement('label');
			iosHapticLabel.style.cssText = 'position:fixed;opacity:.0001;width:1px;height:1px;pointer-events:none;';
			iosHapticLabel.appendChild(iosInput);
			document.body.appendChild(iosHapticLabel);
		}

		function haptic() {
			if (navigator.vibrate) {
				navigator.vibrate(10);
			} else if (iosHapticLabel) {
				iosHapticLabel.click();
			}
		}

		// ---- Тач-управление для мобильных ----
		var touchActive = null;
		var touchStartY = 0;
		var touchMoved = false;
		var touchTimer = null;

		function itemFromPoint(x, y) {
			var el = document.elementFromPoint(x, y);
			if (!el) return null;
			var btn = el.closest ? el.closest('.section-nav__item') : null;
			if (!btn) return null;
			return items.find(function(it) { return it.btn === btn; }) || null;
		}

		function showTouch(item) {
			if (touchActive === item) return;
			if (touchActive) touchActive.btn.classList.remove('touch-visible');
			// Микровибрация при переходе между черточками
			if (item && touchActive) haptic();
			touchActive = item;
			if (item) item.btn.classList.add('touch-visible');
		}

		function hideTouch(delay) {
			clearTimeout(touchTimer);
			var prev = touchActive;
			if (!prev) return;
			touchTimer = setTimeout(function() {
				prev.btn.classList.remove('touch-visible');
				if (touchActive === prev) touchActive = null;
			}, delay || 0);
		}

		nav.addEventListener('touchstart', function(e) {
			clearTimeout(touchTimer);
			var t = e.touches[0];
			touchStartY = t.clientY;
			touchMoved = false;
			showTouch(itemFromPoint(t.clientX, t.clientY));
			e.preventDefault();
		}, { passive: false });

		nav.addEventListener('touchmove', function(e) {
			var t = e.touches[0];
			if (Math.abs(t.clientY - touchStartY) > 6) touchMoved = true;
			showTouch(itemFromPoint(t.clientX, t.clientY));
			e.preventDefault();
		}, { passive: false });

		nav.addEventListener('touchend', function(e) {
			var t = e.changedTouches[0];
			var item = itemFromPoint(t.clientX, t.clientY) || touchActive;
			if (!touchMoved && item) {
				// Тап: переход к секции, название остаётся 1.5с
				scrollTo(item.section);
				hideTouch(1500);
			} else {
				// Свайп закончен: скрыть название через 0.6с
				hideTouch(600);
			}
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
// ========== /SECTION SIDE NAV ==========
